import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../../_augmentt/selectors/customers'
import { getCustomerLicenses, syncCustomerLicenses } from '../crud/licenses.crud'
import useApiControls from './useApiControls'

const INITIAL_DATA = []

const useCustomerLicenses = ({ autoFetch = false } = {}) => {
  // selectors
  const customerId = useSelector(getSelectedCustomerId)

  const organizationId = useSelector(({ user }) => user?.data?.organization)

  const userId = useSelector(({ user }) => user?.data?.id)

  // fetch controls
  const fetchControls = useApiControls({ api: getCustomerLicenses, initialData: INITIAL_DATA })
  const fetchCustomerLicenses = fetchControls.callApi

  // sync controls
  const syncLicensesForSelectedCustomer = useCallback(
    () => syncCustomerLicenses({ customerId, organizationId, userId }), // bind the parameters to call syncCustomerLicenses for customer
    [customerId, organizationId, userId],
  )

  const syncControls = useApiControls({ api: syncLicensesForSelectedCustomer }) // loading, error, data, callApi

  // auto fetch customer licenses on mount and on customer change if autoFetch flag is true
  useEffect(() => {
    if (autoFetch && customerId) {
      fetchCustomerLicenses({ customerId })
    }
  }, [autoFetch, customerId, fetchCustomerLicenses])

  // auto fetch customer licenses after a sync is successful
  const isSyncSuccess = syncControls.success
  const resetSyncControls = syncControls.reset
  useEffect(() => {
    if (isSyncSuccess) {
      resetSyncControls()
      fetchCustomerLicenses({ customerId }, { clearDataBeforeRequesting: false })
    }
  }, [isSyncSuccess, resetSyncControls, customerId, fetchCustomerLicenses])

  return {
    // fetch
    fetchCustomerLicenses,
    isFetchingCustomerLicenses: fetchControls.loading,
    errorFetchingCustomerLicenses: fetchControls.error,
    customerLicenses: fetchControls.data,

    // sync
    syncCustomerLicenses: syncControls.callApi,
    isSyncingCustomerLicenses: syncControls.loading,
  }
}

export default useCustomerLicenses
